/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Invitation_InvalidInputs */

const es_co2_signup_invitation_invalid = /** @type {(inputs: Signup_Invitation_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta invitación no es válida o ya expiró.`)
};

/**

* @param {Signup_Invitation_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_invitation_invalid = /** @type {((inputs?: Signup_Invitation_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Invitation_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_invitation_invalid(inputs)
});